import DatatablesController from "../../../datatables_controller";

export default class extends DatatablesController {
  connect() {
    super.connect();
    this.bindChangeDateFilter();
    this.bindResetFilter();
  }

  datatableLayout() {
    return {
      scroll: true,
      footer: false,
    };
  }

  datatableSearch() {
    return {
      input: $("#kt_ac_users_search_query"),
      delay: 400,
      key: "search",
    };
  }

  datatableFilter() {
    $("#kt_ac_users_search_role").on(
      "change",
      function (e) {
        this.datatable.search(e.target.value, e.target.dataset.paramName);
      }.bind(this),
    );

    $("#kt_ac_users_search_status").on(
      "change",
      function (e) {
        this.datatable.search(e.target.value, e.target.dataset.paramName);
      }.bind(this),
    );
  }

  bindResetFilter() {
    $("#kt_ac_users_reset_filter").on(
      "click",
      function () {
        $("#kt_ac_users_search_query").val("");
        $("#kt_ac_users_search_role").val("").trigger("change.select2");
        $("#kt_ac_users_search_status").val("").trigger("change.select2");
        $("#kt_ac_users_daterangepicker")
          .find(".daterange-label")
          .html("Tgl Bergabung");

        this.datatable.setDataSourceParam("daterange", "");
        this.datatable.setDataSourceParam("query", {});
        this.datatable.load();
      }.bind(this),
    );
  }

  bindChangeDateFilter() {
    var el = $("#kt_ac_users_daterangepicker");
    if (el.length === 0) return;

    var start = moment().subtract(29, "days");
    var end = moment();

    function cb(s, e) {
      el.find(".daterange-label").html(
        s.format("DD MMM") + " - " + e.format("DD MMM"),
      );
    }

    el.daterangepicker({
      startDate: start,
      endDate: end,
      opens: "left",
      autoUpdateInput: false,
      applyClass: "btn-primary",
      cancelClass: "btn-light-primary",
      locale: { cancelLabel: "Reset" },
      ranges: {
        "7 Hari Terakhir": [moment().subtract(6, "days"), moment()],
        "30 Hari Terakhir": [moment().subtract(29, "days"), moment()],
        "Bulan Ini": [moment().startOf("month"), moment().endOf("month")],
        "Bulan Lalu": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    });

    el.on(
      "apply.daterangepicker",
      function (e, picker) {
        cb(picker.startDate, picker.endDate);
        this.datatable.setDataSourceParam(
          "daterange",
          `${picker.startDate.format("DD/MM/YYYY")}-${picker.endDate.format("DD/MM/YYYY")}`,
        );
        this.datatable.load();
      }.bind(this),
    );

    el.on(
      "cancel.daterangepicker",
      function () {
        el.find(".daterange-label").html("Tgl Bergabung");
        this.datatable.setDataSourceParam("daterange", "");
        this.datatable.load();
      }.bind(this),
    );
  }

  datatableColumns() {
    return [
      {
        field: "index",
        title: "No",
        sortable: false,
        width: 25,
        type: "number",
        selector: false,
        textAlign: "center",
        overflow: "visible",
        autoHide: false,
        template: function (data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        },
      },
      {
        field: "created_at",
        title: "Tgl Bergabung",
        sortable: true,
        overflow: "visible",
        autoHide: false,
        width: 140,
        template: function (data) {
          return `
            <span class="font-weight-bolder">${data.joined_at}</span>
            <span data-controller="base--popover" data-base--popover-html="1" data-base--popover-trigger="hover" data-title="Detail Tanggal" data-content="<b>Bergabung Instansi:</b> ${data.uc_created_at}<br/><b>Akun Terdaftar:</b> ${data.user_created_at}" class="svg-icon ml-1" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24"/>
                  <circle fill="#ffffff" opacity="0.3" cx="12" cy="12" r="10"/>
                  <rect fill="#ffffff" x="11" y="10" width="2" height="7" rx="1"/>
                  <rect fill="#ffffff" x="11" y="7" width="2" height="2" rx="1"/>
                </g>
              </svg>
            </span>
          `;
        },
      },
      {
        field: "name",
        title: "User",
        sortable: true,
        textAlign: "left",
        overflow: "visible",
        autoHide: false,
        width: 200,
        template: function (data) {
          return `
            <div class="d-flex align-items-center">
              <div class="symbol symbol-40 symbol-sm flex-shrink-0">
                <img class="" src="${data.user_avatar_url}" alt="photo">
              </div>
              <div class="ml-4">
                <div class="font-weight-bolder font-size-lg mb-0" style="color: #fff;">${data.name}</div>
                <span class="font-weight-bold" style="color: #B5B5C3;">${data.company_name}</span>
              </div>
            </div>
          `;
        },
      },
      {
        field: "email",
        title: "Email",
        sortable: true,
        overflow: "visible",
        autoHide: false,
        width: 200,
        template: function (data) {
          return `<span class="font-weight-bolder">${data.email}</span>`;
        },
      },
      {
        field: "total_video",
        title: "Jumlah Video Materi Ditonton",
        sortable: false,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.total_video}</span>`;
        },
      },
      {
        field: "total_finished_video",
        title: "Jumlah Video Materi Selesai",
        sortable: false,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.total_finished_video}</span>`;
        },
      },
      {
        field: "class_attendants",
        title: "Jumlah Kelas Wajib dihadiri",
        sortable: false,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.class_attendants}</span>`;
        },
      },
      {
        field: "finished_exams",
        title: "Ujian Diselesaikan",
        sortable: false,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.finished_exams}</span>`;
        },
      },
      {
        field: "finished_certificate",
        title: "Sertifikat Selesai / Didownload",
        sortable: false,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.finished_certificate}</span>`;
        },
      },
      {
        field: "total_duration_video",
        title: "Total Durasi Belajar",
        sortable: true,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.total_duration_video}</span>`;
        },
      },
      {
        field: "completion_rate",
        title: "Completion Rate",
        sortable: true,
        overflow: "visible",
        autoHide: false,
        textAlign: "center",
        template: function (data) {
          return `<span class="font-weight-bolder">${data.completion_rate}</span>`;
        },
      },
      {
        field: "actions",
        title: "Actions",
        sortable: false,
        width: 280,
        overflow: "visible",
        autoHide: false,
        template: function (data) {
          return `
            <a class="btn btn-sm btn-primary mr-4" href="${data.show_action}" title="Download">
              <i class="fa fa-eye mr-1"></i>
              Lihat Detail
            </a>

            <a class="btn btn-sm btn-success mr-4" href="https://wa.me/${data.formatted_phone}" target="_blank" title="Followup WA">
              <i class="fab fa-whatsapp mr-1"></i>
              Chat WA
            </a>
          `;
        },
      },
    ];
  }
}
